
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 424"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M338.5 110h37l-77 76.24c-27.885 27.595-73.095 27.595-101 0L120.47 110h37.03l58.5 57.915a45.555 45.555 0 0063.955 0zM157.025 322H120l77.5-76.71c27.885-27.595 73.095-27.595 101 0L376 322h-37l-59-58.385a45.555 45.555 0 00-63.955 0z"}})])
          )
        }
      }
    